import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { searchIconSmall } from "../../assets/svgs";
import styles from "./ui.module.scss";

export const Form = ({ query, setQuery }) => {
  const { t } = useTranslation();

  const [value, setValue] = useState(query || "");

  // V2
  useEffect(() => {
    setValue(query || "");
  }, [query]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setQuery(value.trim());
  };

  const handleInputChange = (e) => {
    const inputValue = e.target.value;
    setValue(inputValue);

    if (!inputValue) {
      setQuery("");
    }
  };
  //

  //  V1
  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   if (value) {
  //     setQuery({ query: value });
  //   }
  // };

  // const handleInputChange = (e) => {
  //   const inputValue = e.target.value;
  //   if (!inputValue) {
  //     setQuery({ query: null });
  //     setValue("");
  //   } else {
  //     setValue(inputValue);
  //   }
  // };
  //

  return (
    <form className={styles.form} onSubmit={handleSubmit}>
      <input
        type="text"
        aria-label="query"
        value={value}
        required={!query}
        onChange={handleInputChange}
      />
      <button type="submit" aria-label={t("search")} title={t("search")}>
        {searchIconSmall.icon}
      </button>
    </form>
  );
};
